
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Point } from "../../../domain/drawing";
import { AsyncRequestPool } from "../../../utilities";
import { MouseTrackableMixin } from ".";

@Component({
})
export default class PointsLayoutableMixin extends Mixins(MouseTrackableMixin) {
  data(): any {
    return {
      pointsLayouterRequestPool: new AsyncRequestPool<Point[], { result: Point[] }>(),
    };
  }
  pointsLayouterRequestPool: AsyncRequestPool<Point[], { result: Point[] }>;

  get isPointsLayouting(): boolean {
    return this.pointsLayouterRequestPool.isProcessing
      && !!this.pointsLayouterRequestPool.processingRequest.source.result
      && ((this.pointsLayouterRequestPool.processingRequest.source.result.length === 0) || this.isMouseLeftButtonPressed);
  }

  get layouterPoints(): Point[] {
    return this.isPointsLayouterVisible
      ? this.pointsLayouterRequestPool.processingRequest.source.result
      : [] as Point[];
  }

  get isPointsLayouterVisible(): boolean {
    return this.isPointsLayouting
      && (0 < this.pointsLayouterRequestPool.processingRequest.source.result.length);
  }

  @Watch("isMouseLeftButtonPressed")
  onMouseLeftButtonClickedForPointsLayouter(newValue: boolean, oldValue: boolean) {
    this.addPointsLayoutingPoints(this.mouseLocation);
  }

  @Watch("mouseLocation")
  onMouseLocationUpdatedForPointsLayouter(newValue: Point, oldValue: Point) {
    this.addPointsLayoutingPoints(newValue);
  }

  private addPointsLayoutingPoints(value: Point) {
    if (!this.isPointsLayouting || !this.pointsLayouterRequestPool.processingRequest.source.result || !this.isMouseLeftButtonPressed) {
      return;
    }
    this.pointsLayouterRequestPool.processingRequest.source.result.splice(this.pointsLayouterRequestPool.processingRequest.source.result.length, 0, value);
  }

  async layoutPoints(): Promise<Point[]> {
    return this.pointsLayouterRequestPool.request(
      {
        result: [],
      },
      this,
      async (source: { result: Point[] }) => {
        await this.$wait(() => !this.isPointsLayouting);
        return (!source.result || (source.result.length === 0))
          ? null
          : source.result;
      },
    );
  }

  cancelPointsLayouting(): void {
    this.pointsLayouterRequestPool.cancel(this);
  }
}
